
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/purchases?${queryString}`);
    return response.data;
  },

  async getById(id) {
    const response = await https.get(`/purchases/${id}`);
    return response.data.data;
  },
  

  async add(payload) {
    const response = await https.post(`/purchases`, payload);
    return response.data;
  },
  async update(id, payload) {
    console.log(payload,'payload')
    const response = await https.put(`/purchases/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/purchases/${id}`);
    return response.data;
  },

  // PDF supplier-order import (Zhejiang Zhongding "26GLRQD..." invoice
  // format). preview() parses + matches without writing anything;
  // confirm() creates the Purchase from the reviewer-approved rows.
  async importPreview(file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await https.post('/supplier-order-import/preview', formData);
    return response.data;
  },
  async importConfirm(payload) {
    const response = await https.post('/supplier-order-import/confirm', payload);
    return response.data;
  },
});
